import {Link} from '@wandb/components';
import {isNotNullOrUndefined} from '@wandb/weave/common/util/types';
// @todo: Migrate to 'Slider' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Slider} from '@wandb/weave/components';
// @todo: Migrate to 'Dialog.Alert' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Alert} from '@wandb/weave/components/Alert.styles';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button/Button';
// @todo: Migrate to 'Checkbox' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Checkbox} from '@wandb/weave/components/Checkbox/Checkbox';
// @todo: Migrate to 'Dialog.Modal' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as Dialog from '@wandb/weave/components/Dialog';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// @todo: Migrate to 'PotentialRoadmap' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Loading} from '@wandb/weave/components/Loading';
// @todo: Migrate to 'Pill' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Pill} from '@wandb/weave/components/Tag/Pill';
import {Tailwind} from '@wandb/weave/components/Tailwind';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import {extractErrorMessageFromApolloError} from '@wandb/weave/errors';
import numeral from 'numeral';
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import ReactMarkdown from 'react-markdown';
import {useHistory} from 'react-router-dom';
// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from 'react-toastify';
import {twMerge} from 'tailwind-merge';

import {
  Banner,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../../components/Banner';
import {AccountSelectorContext} from '../../../components/Search/SearchNav/AccountSelectorContextProvider';
import WBLogo from '../../../components/WBLogo';
import {
  type CheckoutPreviewLineItemsMetadata,
  type CheckoutPreviewQuery,
  type Coupon,
  UsageType,
  useCheckoutPreviewQuery,
  useMakeOrgMembersNoAccessModelsSeatMutation,
  useTrialEndCouponInfoQuery,
  useUpgradeProCustomerMutation,
  useWeaveSavingsCalculatorQuery,
  WeaveIngestionLimitInMb,
} from '../../../generated/graphql';
import {Analytics} from '../../../services/analytics';
import {
  getModelSeatsSub,
  getPrimarySub,
  getWeaveCommitSub,
  getWeaveOverageSubBillingPeriod,
  isCommunityEditionPrimarySubscription,
  isPrimaryStripePlanInfoWithUnitPrice,
  isProPrimarySubscription,
  type Org,
  type OrganizationFlags,
  type PrimaryStripePlanInfoWithUnitPrice,
  StripeElementsComp,
  useAccountPrivileges,
  useGetMinimumModelsSeatsToPurchase,
  useGetSubscriptionPlanByName,
  weaveCommitPlanNameToWeaveIngestionLimit,
} from '../../../util/accounts/pricing';
import {TOP_NAV_HEIGHT} from '../../../util/constants';
import {doNotRetryContext, propagateErrorsContext} from '../../../util/errors';
import {jsonParseSafe} from '../../../util/json';
import {
  useRampFlagInferenceCatalog,
  useRampProPlanMonthlyOption,
} from '../../../util/rampFeatureFlags';
import {
  historicUsageTab,
  privacyPolicy,
  termsOfService,
} from '../../../util/urls';
import {
  getIntervalMarkersFromSubscription,
  useGetUsageThisBillingPeriod,
} from '../../../util/usage/utils';
import {TABS} from '../../HistoricUsage/HistoricUsage';
import {
  customLinkRenderer,
  getCouponDescription,
} from '../AccountSettings/BillingTab/PlanCard/PlanCardComponents';
import {PlanName} from '../util';
import {BillingAddressContextProvider} from './BillingAddressContext';
import {
  NewCheckoutModalContext,
  NewCheckoutModalUpdaterContext,
} from './NewCheckoutModalContext';
import {
  NewStripeForm,
  type RenderButtonsParams,
  type SubmitParams,
} from './NewStripeForm';
import {NumberInputWithRange} from './TeamsPlanTab';
import {useUpgradeSubscriptionToProPlan} from './util';

type CheckoutSectionProps = {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
};

const CheckoutSection: React.FC<CheckoutSectionProps> = ({
  title,
  isOpen,
  onToggle,
  children,
}) => {
  return (
    <div data-test="checkout-section">
      <button
        className="flex w-full cursor-pointer items-center gap-8 py-8"
        onClick={onToggle}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onToggle();
          }
        }}>
        <Icon
          name="chevron-next"
          className={twMerge(
            'text-16 transition-transform',
            isOpen ? 'rotate-90' : ''
          )}
        />
        <h3 className="text-24 text-gray-900 font-semibold">{title}</h3>
      </button>
      {isOpen && <div className="-mt-2 pl-[30px]">{children}</div>}
    </div>
  );
};

type ModelsSeatsSelectorProps = {
  modelSeats: number;
  setModelSeats: (seats: number) => void;
  minSeats: number;
  isMonthly: boolean;
};

const ModelsSeatsSelector: React.FC<ModelsSeatsSelectorProps> = ({
  modelSeats,
  setModelSeats,
  minSeats,
  isMonthly,
}) => {
  return (
    <div className="night-aware" data-test="models-seats-selector">
      <p className="text-[14px] text-moon-500">
        Add seats to enable logging runs and experiments with our wandb SDK.
      </p>
      <div className="mt-12 rounded-lg border border-moon-250 bg-white p-12">
        <div className="night-aware flex items-center justify-between">
          <div className="flex items-center gap-8">
            <p className="text-16 text-gray-900 font-semibold">Models seats</p>
            <Pill label="1 seat free" color="teal" icon="lightboard" />
          </div>
          <NumberInputWithRange
            min={minSeats}
            max={10}
            value={modelSeats}
            setValue={setModelSeats}
            showReduceTooltip={modelSeats > 1 && modelSeats === minSeats}
          />
        </div>
        <p className="text-14 mt-8 text-moon-500">
          Additional seats ${isMonthly ? '60' : '600'}/
          {isMonthly ? 'month' : 'year'}
        </p>
      </div>
    </div>
  );
};

type WeaveIngestionSelectorProps = {
  minWeaveIngestion: WeaveIngestionLimitInMb;
  weaveIngestion: WeaveIngestionLimitInMb;
  setWeaveIngestion: (limit: WeaveIngestionLimitInMb) => void;
  weaveUsage: number;
  weaveLimit: number | undefined;
  orgName: string;
  orgID: string;
};

const WeaveIngestionSelector: React.FC<WeaveIngestionSelectorProps> = ({
  minWeaveIngestion,
  weaveIngestion,
  setWeaveIngestion,
  weaveUsage,
  weaveLimit,
  orgName,
  orgID,
}) => {
  const history = useHistory();
  const {data: weaveSavingsData, loading: weaveSavingsLoading} =
    useWeaveSavingsCalculatorQuery({
      variables: {organizationID: orgID},
      context: propagateErrorsContext(),
    });

  const renderSavingsMessage = () => {
    if (weaveSavingsLoading) {
      return '';
    }

    const savings =
      weaveSavingsData?.weaveSavingsCalculator?.totalPossibleSavings;
    const recommendedTier =
      weaveSavingsData?.weaveSavingsCalculator?.recommendedWeaveTier;

    if (!savings || !recommendedTier) {
      return '';
    }

    return `Save $${savings} per year in overage fees by upgrading to a ${recommendedTier} plan. `;
  };

  const availableLimits = [
    WeaveIngestionLimitInMb.Limit_1500,
    WeaveIngestionLimitInMb.Limit_2000,
    WeaveIngestionLimitInMb.Limit_3500,
    WeaveIngestionLimitInMb.Limit_5000,
    WeaveIngestionLimitInMb.Limit_6500,
    WeaveIngestionLimitInMb.Limit_8000,
    WeaveIngestionLimitInMb.Limit_10000,
    WeaveIngestionLimitInMb.Limit_12500,
    WeaveIngestionLimitInMb.Limit_15000,
    WeaveIngestionLimitInMb.Limit_20000,
    WeaveIngestionLimitInMb.Limit_25000,
    WeaveIngestionLimitInMb.Limit_30000,
    WeaveIngestionLimitInMb.Limit_35000,
  ];

  const minIndex = availableLimits.indexOf(minWeaveIngestion);
  const currentValue = availableLimits.indexOf(weaveIngestion);
  const handleWeaveIngestionChange = (value: number) => {
    if (value < minIndex) {
      setWeaveIngestion(availableLimits[minIndex]);
    } else {
      setWeaveIngestion(availableLimits[value]);
    }
  };

  const getLimitInMBFromWeaveIngestionLimit = (
    limit: WeaveIngestionLimitInMb
  ): number => {
    switch (limit) {
      case WeaveIngestionLimitInMb.Limit_1500:
        return 1500;
      case WeaveIngestionLimitInMb.Limit_2000:
        return 2000;
      case WeaveIngestionLimitInMb.Limit_3500:
        return 3500;
      case WeaveIngestionLimitInMb.Limit_5000:
        return 5000;
      case WeaveIngestionLimitInMb.Limit_6500:
        return 6500;
      case WeaveIngestionLimitInMb.Limit_8000:
        return 8000;
      case WeaveIngestionLimitInMb.Limit_10000:
        return 10000;
      case WeaveIngestionLimitInMb.Limit_12500:
        return 12500;
      case WeaveIngestionLimitInMb.Limit_15000:
        return 15000;
      case WeaveIngestionLimitInMb.Limit_20000:
        return 20000;
      case WeaveIngestionLimitInMb.Limit_25000:
        return 25000;
      case WeaveIngestionLimitInMb.Limit_30000:
        return 30000;
      case WeaveIngestionLimitInMb.Limit_35000:
        return 35000;
      default:
        return 1500; // Default to minimum limit
    }
  };

  const formatMBValue = (limit: WeaveIngestionLimitInMb): string => {
    const mb = getLimitInMBFromWeaveIngestionLimit(limit);
    if (mb >= 1000) {
      return `${mb / 1000}`;
    }
    return mb.toString();
  };

  const formatGBValue = (limit: WeaveIngestionLimitInMb): string => {
    const mb = getLimitInMBFromWeaveIngestionLimit(limit);
    const gb = mb / 1000;
    return `${gb.toFixed(1)} gb/month`;
  };

  const formatWeaveLimitsValue = (value: number) =>
    numeral(value).format('0.0b');

  return (
    <div className="night-aware" data-test="weave-ingestion-selector">
      <p className="text-[14px] text-moon-500">
        Add MBs to log traces and run evaluations. First 1.5GB free, overages
        billed at $0.10/MB monthly.
      </p>
      <div className="mt-12 rounded-lg border border-moon-250 bg-white p-12">
        <div className="grid grid-cols-[1fr_auto] items-center gap-12">
          <div className="night-aware relative pt-4">
            <Slider.Root
              min={0}
              max={availableLimits.length - 1}
              step={1}
              value={[currentValue]}
              onValueChange={([newVal]) => handleWeaveIngestionChange(newVal)}>
              <Slider.Track>
                <Slider.Range className="bg-teal-600" />
              </Slider.Track>
              <div className="absolute mb-[-36px] flex w-full justify-between">
                {availableLimits.map((limit, index) => {
                  const limitMB = getLimitInMBFromWeaveIngestionLimit(limit);
                  const minMB =
                    getLimitInMBFromWeaveIngestionLimit(minWeaveIngestion);
                  const isDisabled = limitMB < minMB;
                  return (
                    <div key={index} className="flex flex-col items-center">
                      <Tooltip
                        position="bottom right"
                        trigger={
                          <span
                            className={twMerge(
                              'transition-colors',
                              isDisabled
                                ? 'text-moon-500'
                                : 'text-gray-900 hover:text-teal-600'
                            )}>
                            {formatMBValue(limit)}
                          </span>
                        }>
                        <div className="text-12 max-w-[300px] p-8">
                          {limit === WeaveIngestionLimitInMb.Limit_35000 ? (
                            <>
                              <div>35 gb/month</div>
                              <div>
                                To increase data above 35gb/month contact
                              </div>
                              <div>
                                <a
                                  href="mailto:support@wandb.com"
                                  className="underline hover:text-teal-500">
                                  support@wandb.com
                                </a>
                              </div>
                            </>
                          ) : (
                            <>
                              {formatGBValue(limit)}
                              {isDisabled && (
                                <div>
                                  To reduce data below current plan
                                  <br />
                                  Contact{' '}
                                  <a
                                    href="mailto:support@wandb.com"
                                    className="underline hover:text-teal-500">
                                    support@wandb.com
                                  </a>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </Tooltip>
                    </div>
                  );
                })}
              </div>
              <Slider.Thumb />
            </Slider.Root>
          </div>
        </div>
        <div className="night-aware mt-30">
          <div className="text-gray-900 mt-12 flex items-center justify-between border-t border-moon-250 pt-12 font-semibold" />
          <div className="flex items-center">
            <Icon name="lightboard" className="mr-8 text-teal-600" />
            <span className="text-gray-900">
              <span className="font-semibold">
                You used {formatWeaveLimitsValue(weaveUsage) ?? 0}{' '}
                {weaveLimit !== undefined
                  ? ' of your ' +
                    formatWeaveLimitsValue(weaveLimit) +
                    ' limit this billing cycle'
                  : 'so far this month'}
                .
              </span>{' '}
              {renderSavingsMessage()}
              <Link
                href={historicUsageTab(
                  orgName,
                  TABS[UsageType.Weave]?.urlPart ?? ''
                )}>
                View usage
              </Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

type CheckoutSummaryProps = {
  isAlreadyPro: boolean;
  checkoutPreviewData?: CheckoutPreviewQuery;
  checkoutPreviewLoading: boolean;
  coupon?: Coupon | null;
  isTermsChecked: boolean;
  onTermsChange: (checked: boolean) => void;
  isUpgradingFromMonthlyPlanToYearlyPlan?: boolean;
};

const getLineItems = (
  isAlreadyPro: boolean,
  filteredItems: CheckoutPreviewLineItemsMetadata[]
) => {
  if (isAlreadyPro && filteredItems.length === 0) {
    // make fake CheckoutPreviewLineItemsMetadata when no changes
    return [
      {
        __typename: 'CheckoutPreviewLineItemsMetadata',
        description: 'No plan changes',
        amount: 0,
        discountAmount: null,
        position: 0,
        product: '',
        subLineItems: [],
      },
    ] as CheckoutPreviewLineItemsMetadata[];
  }

  // Sort items by position
  return [...filteredItems].sort((a, b) => a.position - b.position);
};

type LineItemProps = CheckoutPreviewLineItemsMetadata & {
  isAlreadyPro: boolean;
  showItemDiscount: boolean;
  coupon?: Coupon | null;
  isUpgradingFromMonthlyPlanToYearlyPlan?: boolean;
};

const LineItem: React.FC<LineItemProps> = ({
  description,
  amount,
  position,
  discountAmount,
  product,
  subLineItems,
  isAlreadyPro,
  showItemDiscount,
  coupon,
  isUpgradingFromMonthlyPlanToYearlyPlan = false,
}) => {
  const originalPrice = position === 0 ? Math.abs(amount / 100) : amount / 100;
  const discount = discountAmount ?? 0;
  const discountedPrice =
    position === 0
      ? Math.abs((amount - discount) / 100)
      : (amount - discount) / 100;

  const canCustomerBuyMonthly = useRampProPlanMonthlyOption();

  return (
    <div className="mb-16">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <span className="text-14 text-gray-900 flex items-center font-semibold">
            {product}
            {/*Add tooltip to explain credit breakdown to user*/}
            {/*item.position 0 will always correspond to monthly credit, check services/gorilla/internal/stripe/stripe.go*/}
            {position === 0 && isUpgradingFromMonthlyPlanToYearlyPlan && (
              <Tooltip
                trigger={<Icon name="info" className="ml-8 text-moon-500" />}>
                <Tailwind>
                  <div className="text-12 max-w-[200px] p-8">
                    <div className="flex flex-col gap-4">
                      {subLineItems
                        ?.filter(item => item?.description)
                        .map((item, index) => (
                          <div key={index} className="flex justify-between">
                            <span className="flex items-start">
                              <span className="mr-2 mt-1">•</span>
                              <span>{item?.description ?? ''}</span>
                            </span>
                            <span className="ml-2 font-semibold">
                              ${Math.abs((item?.amount ?? 0) / 100)}
                            </span>
                          </div>
                        )) ?? 'No additional details'}
                    </div>
                    {subLineItems && subLineItems.length > 0 && (
                      <>
                        <div className="border-gray-300 my-4 border-t" />
                        <div className="flex justify-between font-semibold">
                          <span>Total credits applied</span>
                          <span>
                            $
                            {Math.abs(
                              subLineItems
                                .filter(item => item?.description)
                                .reduce(
                                  (sum, item) => sum + (item?.amount ?? 0),
                                  0
                                ) / 100
                            )}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </Tailwind>
              </Tooltip>
            )}
            {showItemDiscount && coupon && (
              <Pill
                label={getCouponDescription(coupon)}
                color="gold"
                className="ml-8"
              />
            )}
          </span>
          {description && (
            <div className="text-12 text-moon-500">
              <ReactMarkdown components={customLinkRenderer}>
                {description}
              </ReactMarkdown>
            </div>
          )}
        </div>
        <span className="text-14 text-gray-700 flex items-center">
          {showItemDiscount ? (
            <>
              <s className="text-gray-400 mr-4">${originalPrice}</s>$
              {discountedPrice}
            </>
          ) : (
            `$${originalPrice}`
          )}
        </span>
      </div>
      {!canCustomerBuyMonthly &&
        isAlreadyPro &&
        (subLineItems ?? []).length > 0 && (
          <div className="ml-16 mt-8">
            {subLineItems.map(
              (subItem, subIndex) =>
                subItem && (
                  <div
                    key={subIndex}
                    className="text-11 text-gray-700 flex items-center justify-between">
                    <span>{subItem.description ?? ''}</span>
                    <span>${subItem.amount / 100}</span>
                  </div>
                )
            )}
          </div>
        )}
    </div>
  );
};

const PaymentCycleSelector: React.FC<{
  isMonthly: boolean;
  onBillingChange: (isMonthly: boolean) => void;
  isAlreadyOnYearly?: boolean;
}> = ({isMonthly, onBillingChange, isAlreadyOnYearly = false}) => {
  return (
    <div className="mb-16">
      <h2 className="night-aware text-18 mb-8 font-semibold text-moon-900">
        Payment cycle
      </h2>
      {isAlreadyOnYearly ? (
        <div className="text-14 text-gray-900">
          Billed annually <span className="text-teal-600">(save 17%)</span>
        </div>
      ) : (
        <div className="flex items-center gap-24">
          <div className="flex items-center gap-8">
            <input
              type="radio"
              id="monthly"
              name="billing"
              checked={isMonthly}
              onChange={() => onBillingChange(true)}
              className="h-16 w-16"
            />
            <label htmlFor="monthly" className="text-14 text-gray-900">
              Billed monthly
            </label>
          </div>
          <div className="flex items-center gap-8">
            <input
              type="radio"
              id="yearly"
              name="billing"
              checked={!isMonthly}
              onChange={() => onBillingChange(false)}
              className="h-16 w-16"
            />
            <label htmlFor="yearly" className="text-14 text-gray-900">
              Billed annually <span className="text-teal-600">(save 17%)</span>
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

const CheckoutPlanSummary: React.FC<CheckoutSummaryProps> = ({
  isAlreadyPro,
  checkoutPreviewData,
  checkoutPreviewLoading,
  coupon,
  isTermsChecked,
  onTermsChange,
  isUpgradingFromMonthlyPlanToYearlyPlan = false,
}) => {
  const filteredItems =
    checkoutPreviewData?.checkoutPreview?.lineItems?.filter(
      isNotNullOrUndefined
    ) ?? [];

  const discountAppliesToAll =
    filteredItems.length > 0 &&
    filteredItems.every(item => item.discountAmount != null) &&
    coupon != null;

  const totalDiscountAmount = discountAppliesToAll
    ? filteredItems.reduce((sum, item) => sum + (item.discountAmount ?? 0), 0)
    : 0;

  const lineItems = getLineItems(isAlreadyPro, filteredItems);

  const totalAmount = checkoutPreviewData?.checkoutPreview?.total ?? 0;
  const totalWithDiscount = totalAmount + totalDiscountAmount;
  const totalInDollars = totalAmount / 100;
  const totalWithDiscountInDollars = totalWithDiscount / 100;

  const renewalDate = checkoutPreviewData?.checkoutPreview?.renewalDate ?? '';

  const formattedRenewalDate = new Date(renewalDate).toLocaleDateString(
    'en-US',
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
  );

  const {selectedAccount} = useContext(AccountSelectorContext);

  const isInferenceRampEnabled = useRampFlagInferenceCatalog(
    selectedAccount?.name ?? ''
  );

  return (
    <div
      className="night-aware mx-5 flex flex-col rounded-lg border border-moon-250 bg-white dark:border-moon-700 dark:bg-moon-800"
      data-test="pro-plan-summary">
      <div className="bg-gray-50 rounded-t-lg border-b border-moon-250 p-24">
        <h3 className="text-gray-900 text-[20px] font-semibold">
          Plan and Pricing
        </h3>
        <p className="text-14 text-moon-500">All amounts are shown in USD</p>
      </div>
      {isUpgradingFromMonthlyPlanToYearlyPlan && !checkoutPreviewLoading && (
        <div className="px-16 pt-16">
          <Alert severity="info" className="w-full py-20">
            <div className="flex items-center gap-8">
              <Icon name="info" />
              <span>You're saving 17% by switching to the annual plan.</span>
            </div>
          </Alert>
        </div>
      )}
      <div className="p-24">
        <div className="min-h-[50px]">
          {checkoutPreviewLoading ? (
            <div className="flex h-full items-center justify-center">
              <Loading />
            </div>
          ) : (
            lineItems.map((item, index) => {
              const showItemDiscount =
                !discountAppliesToAll &&
                coupon != null &&
                item.discountAmount != null;

              if (!isInferenceRampEnabled && item.position === 6) {
                return;
              }

              return (
                <React.Fragment key={index}>
                  {isUpgradingFromMonthlyPlanToYearlyPlan &&
                    item.position === 1 && (
                      <div className="mb-16">
                        <div
                          className="mb-8 font-semibold text-moon-600"
                          style={{fontSize: '20px'}}>
                          New annual plan
                        </div>
                      </div>
                    )}
                  <LineItem
                    {...item}
                    isAlreadyPro={isAlreadyPro}
                    showItemDiscount={showItemDiscount}
                    coupon={coupon}
                    isUpgradingFromMonthlyPlanToYearlyPlan={
                      isUpgradingFromMonthlyPlanToYearlyPlan
                    }
                  />
                </React.Fragment>
              );
            })
          )}
        </div>
        <div className="text-gray-900 mt-12 flex items-center justify-between border-t border-moon-250 pt-12 font-semibold">
          <span className="flex items-center">
            <span style={{fontSize: '20px'}}>Total due today</span>
            {coupon && discountAppliesToAll && (
              <div className="ml-8">
                <Pill label={getCouponDescription(coupon)} color="gold" />
              </div>
            )}
          </span>
          <span style={{fontSize: '20px'}}>
            {discountAppliesToAll && (
              <s className="text-gray-400 mr-4">
                ${totalWithDiscountInDollars}
              </s>
            )}
            ${totalInDollars}
          </span>
        </div>
        {(!isAlreadyPro || isUpgradingFromMonthlyPlanToYearlyPlan) &&
          renewalDate && (
            <div className="text-gray-700 text-16 mb-8 flex items-center gap-4">
              <Icon name="date" />
              Renewal date: {formattedRenewalDate}
            </div>
          )}
        <div className="-ml-12 flex flex-row items-center">
          <Checkbox
            style={{margin: 12}}
            checked={isTermsChecked}
            onClick={() => {
              onTermsChange(!isTermsChecked);
            }}
          />
          <span className="text-14 text-gray-700">
            I agree to the{' '}
            <Link href={termsOfService()} target="_blank">
              terms of service
            </Link>{' '}
            and{' '}
            <Link href={privacyPolicy()} target="_blank">
              privacy policy
            </Link>
            .
          </span>
        </div>
      </div>
    </div>
  );
};

const performExistingProPlanUpgrade = async (
  finalOrg: Org,
  finalSeats: number,
  finalWeaveIngestion: WeaveIngestionLimitInMb,
  onTransactionCompleted: () => void,
  setUpgrading: (upgrading: boolean) => void,
  updateProOrganizationMutation: ReturnType<
    typeof useUpgradeProCustomerMutation
  >,
  boughtExtraSeats: boolean,
  boughtExtraWeaveIngestion: boolean,
  isMonthly: boolean,
  coupon?: string
) => {
  setUpgrading(true);
  try {
    const updateWeaveTierResults = await updateProOrganizationMutation[0]({
      variables: {
        organizationID: finalOrg.id,
        weaveIngestionTier: finalWeaveIngestion,
        modelsSeats: finalSeats,
        monthly: isMonthly,
      },
    });

    if (updateWeaveTierResults.errors) {
      toast(
        `Error updating weave subscription: ${updateWeaveTierResults.errors}`
      );
    }
  } catch (err) {
    const errMsg = extractErrorMessageFromApolloError(err);
    toast(`Error updating subscription: ${errMsg}`);
  } finally {
    Analytics.track('Pro Plan Upgrade', {
      orgId: finalOrg.id,
      orgName: finalOrg.name,
      seats: finalSeats,
      weaveIngestion: finalWeaveIngestion,
      boughtExtraSeats,
      boughtExtraWeaveIngestion,
      coupon,
    });
    setUpgrading(false);
    onTransactionCompleted();
  }
};

const performFirstTimePurchase = async (
  finalParams: SubmitParams,
  finalOrg: Org,
  finalSelectedPlan: PrimaryStripePlanInfoWithUnitPrice,
  finalSeats: number,
  finalWeaveIngestion: WeaveIngestionLimitInMb,
  isWeaveOnlyUser: boolean,
  onTransactionCompleted: () => void,
  upgradeSubscriptionToPro: ReturnType<typeof useUpgradeSubscriptionToProPlan>,
  makeOrgMembersNoAccessMutation: ReturnType<
    typeof useMakeOrgMembersNoAccessModelsSeatMutation
  >,
  isComingFromTrial: boolean,
  isMonthly: boolean,
  coupon?: string
) => {
  const success = await upgradeSubscriptionToPro(
    finalParams,
    finalSelectedPlan,
    finalSeats,
    finalOrg,
    isWeaveOnlyUser,
    finalWeaveIngestion,
    isMonthly
  );
  if (!success) {
    return false;
  }
  if (!isWeaveOnlyUser) {
    Analytics.track('Pro Plan Purchase', {
      orgId: finalOrg.id,
      orgName: finalOrg.name,
      seats: finalSeats,
      weaveIngestion: finalWeaveIngestion,
      previousPlan: isComingFromTrial ? 'Pro Trial' : 'Free Plan',
      identifiedAsWeaveOnlyUser: isWeaveOnlyUser,
      coupon: coupon,
    });
    onTransactionCompleted();
    return true;
  }

  const {errors: makeOrgNoAccessErrors} =
    await makeOrgMembersNoAccessMutation[0]({
      variables: {organizationId: finalOrg.id},
    });

  if (makeOrgNoAccessErrors != null) {
    const errMsg = makeOrgNoAccessErrors.map(e => e.message).join(', ');
    console.error(`Error updating model seats for org members: ${errMsg}`);
    return false;
  }

  Analytics.track('Pro Plan Purchase', {
    orgId: finalOrg.id,
    orgName: finalOrg.name,
    seats: finalSeats,
    weaveIngestion: finalWeaveIngestion,
    previousPlan: isComingFromTrial ? 'Pro Trial' : 'Free Plan',
    identifiedAsWeaveOnlyUser: isWeaveOnlyUser,
    coupon: coupon,
  });

  onTransactionCompleted();
  return true;
};

type CustomizePlanModalProps = {
  isOpen: boolean;
  onClose: () => void;
  org: Org;
  onTransactionCompleted: () => void;
};

export const CustomizePlanModal: React.FC<CustomizePlanModalProps> = ({
  isOpen,
  onClose,
  org,
  onTransactionCompleted,
}) => {
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const {
    minModelsSeatsToPurchase,
    isWeaveOnlyUser,
    loading: minSeatsToPurchaseLoading,
  } = useGetMinimumModelsSeatsToPurchase(org.name, org.usedSeats);
  const {selectedAccount} = useContext(AccountSelectorContext);
  const [submitting, setSubmitting] = useState(false);
  const [upgrading, setUpgrading] = useState(false);
  const [isModelsSectionOpen, setIsModelsSectionOpen] = useState(true);
  const [isWeaveSectionOpen, setIsWeaveSectionOpen] = useState(true);
  const [stripeFormProps, setStripeFormProps] =
    useState<RenderButtonsParams | null>(null);
  const [stripeFormError, setStripeFormError] = useState<string | null>(null);

  const {loading: loadingPlans, plans} = useGetSubscriptionPlanByName();

  const proYearlyPlan = plans[PlanName.ProAnnual];

  const proMonthlyPlan = plans[PlanName.ProMonthly];

  const primarySub = getPrimarySub(org);
  const isComingFromTrial =
    primarySub?.plan != null &&
    isCommunityEditionPrimarySubscription({
      plan: {name: primarySub.plan.name},
    });
  const isAlreadyProPlan =
    primarySub?.plan != null &&
    isProPrimarySubscription({plan: {name: primarySub.plan.name}});

  const isAlreadyProAnnualPlan =
    primarySub?.plan != null && primarySub?.plan?.name === proYearlyPlan?.name;

  const isAlreadyProMonthlyPlan =
    primarySub?.plan != null && primarySub?.plan?.name === proMonthlyPlan?.name;

  const modelsSeatSub = getModelSeatsSub(org);

  const flags = org?.flags as string;
  const parsedOrgFlags =
    flags != null ? (jsonParseSafe(flags) as OrganizationFlags) : {};
  const orgHasRedeemedCoupon = parsedOrgFlags.coupon_id != null;

  const {data: couponData} = useTrialEndCouponInfoQuery({
    variables: {couponID: parsedOrgFlags.coupon_id as string},
    skip: !orgHasRedeemedCoupon,
    context: propagateErrorsContext(), // if the redeemed coupon is now invalid, we will just ignore the coupon
    fetchPolicy: 'no-cache', // always want the up to date info on the coupon when the user is about to purchase
  });
  const coupon = couponData?.coupon;

  // Determine initial monthly state based on existing subscription
  const getInitialIsMonthly = () => {
    return isAlreadyProPlan && isAlreadyProMonthlyPlan;
  };

  const [isMonthly, setIsMonthly] = useState(getInitialIsMonthly);

  let minSeats = minModelsSeatsToPurchase ?? 1;
  let minIngestion = WeaveIngestionLimitInMb.Limit_1500;

  const [modelSeats, setModelSeats] = useState<number | null>(null);

  // Update modelSeats once minModelsSeatsToPurchase is available
  useEffect(() => {
    if (minModelsSeatsToPurchase !== null && modelSeats === null) {
      setModelSeats(minModelsSeatsToPurchase);
    }
  }, [minModelsSeatsToPurchase, modelSeats]);

  const weaveSub = getWeaveCommitSub(org);

  // if org is already on Pro plan, this is an upgrade, so min-seats and weave ingestion should match existing values
  if (isAlreadyProPlan) {
    minSeats = modelsSeatSub?.seats ?? minSeats;
    const weaveIngestion = weaveCommitPlanNameToWeaveIngestionLimit(
      weaveSub?.plan?.name ?? ''
    );
    if (weaveIngestion != null) {
      minIngestion = weaveIngestion;
    }
    if (modelSeats === null) {
      setModelSeats(minSeats);
    }
  }

  const [weaveIngestion, setWeaveIngestion] =
    useState<WeaveIngestionLimitInMb>(minIngestion);

  const [minWeaveIngestion, setMinWeaveIngestion] =
    useState<WeaveIngestionLimitInMb>(minIngestion);

  const upgradeSubscriptionToPro = useUpgradeSubscriptionToProPlan();

  const updateProOrganizationMutation = useUpgradeProCustomerMutation({
    context: propagateErrorsContext(),
  });

  const makeOrgMembersNoAccessMutation =
    useMakeOrgMembersNoAccessModelsSeatMutation({
      context: propagateErrorsContext(),
    });

  useEffect(() => {
    if (isOpen && !isAlreadyProPlan) {
      if (isWeaveOnlyUser) {
        setIsModelsSectionOpen(false);
        setIsWeaveSectionOpen(true);
      } else {
        setIsModelsSectionOpen(true);
        setIsWeaveSectionOpen(false);
      }
    }
  }, [isOpen, isWeaveOnlyUser, isAlreadyProPlan]);

  const isOnProAndNoChangeToCurrentPlan =
    weaveIngestion === minIngestion &&
    modelSeats === minSeats &&
    ((isMonthly && isAlreadyProMonthlyPlan) || isAlreadyProAnnualPlan);

  const {
    data: checkoutPreviewData,
    refetch: refetchCheckoutPreview,
    loading: checkoutPreviewLoading,
  } = useCheckoutPreviewQuery({
    variables: {
      organizationID: org.id,
      weaveIngestionTier: weaveIngestion,
      numberOfModelsSeat: modelSeats ?? 1,
      couponID: coupon?.id,
      isMonthly: isMonthly,
    },
    // skip the checkout preview when already on Pro and no change to the current plan
    skip:
      minSeatsToPurchaseLoading ||
      isOnProAndNoChangeToCurrentPlan ||
      modelSeats === null,
    context: {...propagateErrorsContext(), ...doNotRetryContext()},
  });

  const handleModelSeatsChange = useCallback(
    (newSeats: number) => {
      setModelSeats(newSeats);
      if (refetchCheckoutPreview) {
        refetchCheckoutPreview();
      }
    },
    [refetchCheckoutPreview]
  );

  const handleWeaveIngestionChange = useCallback(
    (newLimit: WeaveIngestionLimitInMb) => {
      setWeaveIngestion(newLimit);
      if (refetchCheckoutPreview) {
        refetchCheckoutPreview();
      }
    },
    [refetchCheckoutPreview]
  );

  const {privileges, loading: privilegesLoading} =
    useAccountPrivileges(selectedAccount);

  const now = new Date();
  const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  const defaultUsagePeriod = [thirtyDaysAgo, now];

  const weaveBillingPeriod = getWeaveOverageSubBillingPeriod(privileges, org);

  const usagePeriod = isAlreadyProPlan
    ? getIntervalMarkersFromSubscription(weaveBillingPeriod)
    : defaultUsagePeriod;

  const weaveOverageData = useGetUsageThisBillingPeriod(
    selectedAccount,
    UsageType.Weave,
    usagePeriod ?? defaultUsagePeriod,
    org.createdAt === undefined || usagePeriod === null || privilegesLoading
  );

  const handleStripeFormProps = useCallback((props: RenderButtonsParams) => {
    setStripeFormProps(props);
    return null;
  }, []);

  const stateValue = useMemo(() => ({submitting}), [submitting]);
  const updaterValue = useMemo(() => ({setSubmitting}), []);

  const [marginTop, setMarginTop] = useState(0);

  const canCustomerBuyMonthly = useRampProPlanMonthlyOption();

  useEffect(() => {
    const offset = TOP_NAV_HEIGHT;
    const updateMarginTop = () => {
      const scrollY = Math.ceil(window.scrollY);
      if (scrollY < offset) {
        setMarginTop(offset - scrollY);
      } else {
        setMarginTop(0);
      }
    };
    updateMarginTop();
    window.addEventListener('scroll', updateMarginTop);
    window.addEventListener('resize', updateMarginTop);
    return () => {
      window.removeEventListener('scroll', updateMarginTop);
      window.removeEventListener('resize', updateMarginTop);
    };
  }, []);

  if (
    loadingPlans ||
    minSeatsToPurchaseLoading ||
    modelSeats === null ||
    privilegesLoading
  ) {
    return null;
  }

  if (
    proYearlyPlan == null ||
    proMonthlyPlan == null ||
    !isPrimaryStripePlanInfoWithUnitPrice(proYearlyPlan) ||
    !isPrimaryStripePlanInfoWithUnitPrice(proMonthlyPlan)
  ) {
    toast(
      'Something went wrong while upgrading to a higher tier plan. Please reach out to support@wandb.com.'
    );
    return null;
  }

  const isUpgradingFromMonthlyPlanToYearlyPlan =
    isAlreadyProMonthlyPlan && !isMonthly;

  return (
    <Tailwind>
      <Dialog.Root open={isOpen} onOpenChange={onClose}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed z-50" />
          <Dialog.Content
            className="night-aware !left-0 bottom-0 right-0 z-50 flex !translate-x-0 !translate-y-0 items-start justify-center bg-white"
            style={{top: marginTop}}
            data-test="customize-plan-modal">
            <div className="flex h-full w-full flex-col overflow-auto">
              <div className="flex items-center justify-between pb-0 pt-0">
                <div className="flex flex-col items-start">
                  <WBLogo
                    data-test="wb-logo"
                    aria-label="Weights & Biases Logo"
                    className="rounded-full hover:bg-white dark:hover:bg-moon-800"
                  />
                </div>
                <Dialog.Close asChild>
                  <Button
                    variant="ghost"
                    icon="close"
                    onClick={() => {
                      if (!submitting) {
                        onClose();
                      }
                    }}
                    disabled={submitting}
                    className="rounded-full p-8"
                    data-test="customize-plan-modal-close-button">
                    <span className="sr-only">Close</span>
                  </Button>
                </Dialog.Close>
              </div>
              <div className="flex-1 overflow-y-auto">
                <div className="mx-auto max-w-[1400px]">
                  <div className="flex w-full justify-center gap-16">
                    <div className="flex w-[700px] flex-col">
                      <Dialog.Title className="text-24 mb-12 font-semibold">
                        {isAlreadyProPlan
                          ? 'Customize your plan'
                          : 'Upgrade to pro'}
                      </Dialog.Title>
                      {canCustomerBuyMonthly && (
                        <div className="mb-14 mt-14 pl-32">
                          <PaymentCycleSelector
                            isMonthly={isMonthly}
                            onBillingChange={setIsMonthly}
                            isAlreadyOnYearly={isAlreadyProAnnualPlan}
                          />
                        </div>
                      )}
                      <div className="flex-shrink-0">
                        <div className="pb-16">
                          <CheckoutSection
                            title="W&B Models seats to train or fine-tune AI models"
                            isOpen={isModelsSectionOpen}
                            onToggle={() =>
                              setIsModelsSectionOpen(!isModelsSectionOpen)
                            }>
                            <ModelsSeatsSelector
                              modelSeats={modelSeats}
                              setModelSeats={handleModelSeatsChange}
                              minSeats={minSeats}
                              isMonthly={isMonthly}
                            />
                          </CheckoutSection>
                        </div>

                        <div className="py-16">
                          <CheckoutSection
                            title="W&B Weave data ingestion (in GB/mo) to analyze and improve AI apps"
                            isOpen={isWeaveSectionOpen}
                            onToggle={() =>
                              setIsWeaveSectionOpen(!isWeaveSectionOpen)
                            }>
                            <WeaveIngestionSelector
                              minWeaveIngestion={minWeaveIngestion}
                              weaveIngestion={weaveIngestion}
                              setWeaveIngestion={handleWeaveIngestionChange}
                              weaveUsage={weaveOverageData.usage}
                              weaveLimit={
                                privileges.weaveLimits?.weaveLimitBytes
                              }
                              orgName={org.name}
                              orgID={org.id}
                            />
                          </CheckoutSection>
                        </div>

                        <div className="pt-16"></div>
                      </div>

                      <div className="flex min-h-0 flex-1 flex-col pl-32">
                        <h3
                          className="text-24 mb-10 font-semibold"
                          data-test="payment-information-section">
                          Payment information
                        </h3>
                        <div className="min-h-0 flex-1">
                          <div className="night-aware rounded-lg border border-moon-250 bg-white p-6">
                            <BillingAddressContextProvider>
                              <NewCheckoutModalContext.Provider
                                value={stateValue}>
                                <NewCheckoutModalUpdaterContext.Provider
                                  value={updaterValue}>
                                  <StripeElementsComp>
                                    <NewStripeForm
                                      orgName={org.name}
                                      orgID={org.id}
                                      renderButtons={handleStripeFormProps}
                                      onError={setStripeFormError}
                                    />
                                  </StripeElementsComp>
                                </NewCheckoutModalUpdaterContext.Provider>
                              </NewCheckoutModalContext.Provider>
                            </BillingAddressContextProvider>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="night-aware w-[600px] overflow-y-auto">
                      <CheckoutPlanSummary
                        isAlreadyPro={isAlreadyProPlan}
                        checkoutPreviewData={checkoutPreviewData}
                        checkoutPreviewLoading={checkoutPreviewLoading}
                        coupon={coupon}
                        isTermsChecked={isTermsChecked}
                        onTermsChange={setIsTermsChecked}
                        isUpgradingFromMonthlyPlanToYearlyPlan={
                          isUpgradingFromMonthlyPlanToYearlyPlan
                        }
                      />
                      {stripeFormProps && (
                        <Button
                          variant="primary"
                          onClick={async () => {
                            if (!stripeFormProps) {
                              return;
                            }
                            if (isAlreadyProPlan) {
                              return performExistingProPlanUpgrade(
                                org,
                                modelSeats,
                                weaveIngestion,
                                onTransactionCompleted,
                                setUpgrading,
                                updateProOrganizationMutation,
                                modelSeats > minSeats,
                                weaveIngestion !== minIngestion,
                                isMonthly,
                                coupon?.id
                              );
                            }
                            await stripeFormProps.submitWrapper(
                              async (finalParams: SubmitParams) => {
                                return performFirstTimePurchase(
                                  finalParams,
                                  org,
                                  isMonthly ? proMonthlyPlan : proYearlyPlan,
                                  modelSeats,
                                  weaveIngestion,
                                  !!isWeaveOnlyUser,
                                  onTransactionCompleted,
                                  upgradeSubscriptionToPro,
                                  makeOrgMembersNoAccessMutation,
                                  isComingFromTrial,
                                  isMonthly,
                                  coupon?.id
                                );
                              }
                            );
                          }}
                          disabled={
                            stripeFormProps.submitButtonDisabled ||
                            isOnProAndNoChangeToCurrentPlan ||
                            stripeFormProps.submitting ||
                            !isTermsChecked ||
                            upgrading
                          }
                          className="mt-16 w-full">
                          {stripeFormProps.submitting || upgrading
                            ? 'Processing...'
                            : 'Upgrade'}
                        </Button>
                      )}
                      {stripeFormError && (
                        <Banner
                          variant="error"
                          className="night-aware m-16 mx-5">
                          <BannerFlexWrapper>
                            <Icon name="warning" />
                            <BannerTextWrapper>
                              {stripeFormError}
                            </BannerTextWrapper>
                          </BannerFlexWrapper>
                        </Banner>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </Tailwind>
  );
};
